import { createApp } from 'vue';
import { createPinia } from 'pinia';
import OpenLayersMap from 'vue3-openlayers';

import { createVuetify, createI18n, createRouter, setErrorHandlers } from '@core';
import { createAuthGuard } from '@shared';

import routes from './app/routes';
import themes from './app/themes';
import { initForms } from './app/utils/fom.utils';
import messages from './i18n';

import App from './App.vue';

import 'vue3-openlayers/dist/vue3-openlayers.css';
import './assets/scss/styles.scss';

const app = createApp(App);
setErrorHandlers(app);

const pinia = createPinia();
const router = createRouter(routes);
const i18n = createI18n('hu', messages);
const vuetify = createVuetify(i18n, themes, {
  VTextField: {
    variant: 'outlined',
    density: 'compact',
    color: 'primary'
  }
});

initForms();

app.use(pinia);

createAuthGuard(router, 'login');

app.use(router);
app.use(i18n);
app.use(vuetify);
app.use(OpenLayersMap);
app.mount('#app');
